import React, {PureComponent} from 'react';
import Dropzone from 'react-dropzone';
import toastr from 'toastr';
import { getCurrentUserId, getJwt } from '../../services/authService';
import { Intent, ProgressBar, Spinner, SpinnerSize } from '@blueprintjs/core';
import http from '../../services/httpService';
import countries from '../common/countries.json';

export default class FileUpload extends PureComponent{
    state = {
        fileLoaderActive: false,
        uploading: false,
        progress: 0
    }

    // getCSRFToken = async () => {
    //     try{
    //         const response = await http.get('/token', {headers: {authorization: getJwt()}});
    //         return response.data
    //     }catch{
    //         toastr.error('Error with getting token')
    //     }
    //
    // }

    vaporStore = async (file, options = {}) => {
        /**
         * Store a file in S3 and return its UUID, key, and other information.
         */
        // console.log('vaporStore entered')
        /* Getting signed storage url that will be used for uploading file */
        try{
            const response = await http.post(options.signedStorageUrl ? options.signedStorageUrl : '/vapor/signed-storage-url', {
                'bucket': options.bucket || '',
                'content_type': options.contentType || file.type,
                'expires': options.expires || '',
                'visibility': options.visibility || ''
            }, {
                baseURL: options.baseURL || null,
                headers: options.headers || {},
                ...options.options
            });

            let headers = await response.data.headers;

            if ('Host' in headers) {
                delete headers.Host;
            }

            if (typeof options.progress === 'undefined') {
                options.progress = () => {};
            }

            const cancelToken = options.cancelToken || ''

            // console.log('file for Vapor: ', file, response)
            /* Uploading file to Vapor */
            try{
                await http.put(response.data.url, file[0], {
                    cancelToken: cancelToken,
                    headers: headers,
                    onUploadProgress: (progressEvent) => {
                        options.progress(progressEvent.loaded / progressEvent.total);
                        this.props.onUploadProgressChange(progressEvent.loaded / progressEvent.total)
                        this.setState({progress: Math.round(progressEvent.loaded / progressEvent.total * 100)})
                        // console.log('progressEvent for put: ', progressEvent)
                    }
                })
                // response.data.extension = await file.name.split('.').pop();
                // console.log('response.data.extension: ', response.data.extension)

                return response.data;
            }catch{
                return { error: 'File upload failed, please try again.'}
            }

        }catch{
            return { error: 'File Upload Vapor error, please try again.'}
        }

    }

    onDrop = async (acceptedFiles, rejectedFiles) => {
        await this.setState({uploading: true, progress: 0})
        await this.props.onUploadStart()
        // console.log('Evo ga: ', acceptedFiles, rejectedFiles)
        // if(rejectedFiles && rejectedFiles.length){
        //
        // }else if(acceptedFiles && acceptedFiles.length){
        //     if ((window.location.pathname === '/account-verification/personal-details' && this.props.personalDetails.files.length < 5)||
        //         (window.location.pathname === '/account-verification/business-details' && this.props.businessDetails.files.length < 5)
        //     ){
        //         this.setState({files: acceptedFiles, fileLoaderActive: true, dropRejectedData: []})
        //         this.uploadFile(acceptedFiles)
        //         // this.parseCsvFile(acceptedFiles);
        //     }
        // }
        // console.log('acceptedFiles: ', this.refs.file.files[0])
        // console.log('Vapor: ', Vapor.store)
        // return Vapor.store(this.refs.file.files[0], {

        // let csrfToken = await this.getCSRFToken();

        // console.log('csrfToken: ', csrfToken)
        let response = await this.vaporStore(acceptedFiles, {

            signedStorageUrl: process.env.REACT_APP_ENVIRONMENT === 'DEV' ?
                'https://dev-api.emitto.io/vapor/signed-storage-url' : 'https://api.emitto.io/vapor/signed-storage-url',
            // bucket: process.env.REACT_APP_AWS_BUCKET,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                // 'X-CSRF-TOKEN': 'E2qbbo6ul8EW0TT23CBAMXhJAVWYuhvhSTYI3YJr',
                'X-Requested-With': 'XMLHttpRequest',
                // 'X-CSRF-Token': csrfToken.toString(),
                authorization: getJwt()
            },
            visibility: 'public-read',
            // progress: progress => {
            //     console.log('progress: ', progress)
            //     this.uploadProgress = Math.round(progress * 100);
            // }
        })
        // console.log('vaporStore response: ', response)
        if(response.key){
            try{
                let result = await http.post('/api/files/' + getCurrentUserId(), {
                    category: this.props.category ? this.props.category : 'images',
                    // uuid: response.uuid,
                    key: response.key,
                    // bucket: response.bucket,
                    name: acceptedFiles[0].name,
                    // content_type: acceptedFiles[0].type,
                }, {headers: {authorization: getJwt()}});
                await this.props.onUploadEnd(result.data[this.props.category], acceptedFiles[0])
                await this.setState({uploading: false, progress: 0})
                toastr.success("File successfully uploaded!");
            }catch(error){
                toastr.error('Upload error: ', error)
                // console.error('Upload error:', error);
            }
        }else{
            await this.setState({uploading: false, progress: 0})
            if(response && response.error){
                toastr.error(response.error);
            }else{
                toastr.error("File upload unsuccessful, please try again!");
            }
        }


    };
    render(){
        let opacity = this.state.uploading && !this.props.hideLoader ? 0 : 1;

        return(
            <Dropzone
                onDrop={this.onDrop}
                multiple={false}
                accept={this.props.fileType === 'document' ? 'image/jpeg, image/png, image/jpg, .pdf' :
                this.props.fileType === 'csv' ? '.csv' : 'image/jpeg, image/png, image/jpg'}
                maxSize={parseInt(this.props.maxSizeMb) * 1048576}
                // maxFiles={5}
                onDragEnter={() => this.setState({dropZoneHovered: true})}
                onDragLeave={() => this.setState({dropZoneHovered: false})}
                onDropRejected={(e) => {
                    this.setState({fileLoaderActive: false})
                    toastr.error('File type not supported or file to large')
                }}
                disabled={this.props.disabled}
            >
                {({getRootProps, getInputProps}) => (
                    <section className="container">
                        <div {...getRootProps({className: this.state.dropZoneHovered ? 'dropzone hovered' : 'dropzone'})}>
                            <input {...getInputProps()} />
                            {/*{ this.state.uploading && !this.props.hideLoader ?*/}
                            {/*    <div style={{height: 120}}/>*/}
                            {/*    :*/}
                            {/*    ''*/}
                            {/*}*/}

                            <p style={{opacity}}>{ this.props.text ? this.props.text : 'Drag and drop your file here' }<br/><br/></p>

                            <p style={{opacity}} className='small'>or <br/><br/></p>

                            { this.props.buttonType && this.props.buttonType === 'blue' ?
                                <button style={{opacity}} className='btn-action'>
                                    { this.props.buttonText ? this.props.buttonText : 'Upload Image' }
                                </button>
                                :
                                <span style={{opacity}}>{ this.props.buttonText ? this.props.buttonText : 'Browse files' }</span>
                            }
                        </div>
                        {this.state.uploading && !this.props.hideLoader ?
                            <div className='drop-loader'>
                                <div className='half-width'>
                                    <ProgressBar
                                        intent='primary'
                                        value={ this.props.fileType === 'csv' ? 1 : this.state.progress }
                                        animate={ this.props.fileType === 'csv' ? true : false }
                                        stripes={ this.props.fileType === 'csv' ? true : false }/>
                                </div>

                                {/*<Spinner*/}
                                {/*    intent='primary'*/}
                                {/*    size={this.props.loaderSize === 'large' ? SpinnerSize.LARGE :*/}
                                {/*        this.props.loaderSize === 'normal' ? SpinnerSize.STANDARD : SpinnerSize.SMALL}*/}
                                {/*    value={ this.props.fileType === 'csv' ? 1 : this.state.progress }*/}
                                {/*/>*/}
                            </div>
                            :
                            ''
                        }

                    </section>
                )}
            </Dropzone>
        )
    }
}

